import { redirectToSouscription } from "../helpers/souscription";
import { openZendeskWidget } from "../helpers/zendesk";
import { useZeroFranchiseTracking } from "../hooks/useZeroFranchiseTracking";
import { Button } from "./Button";

const PRICING_IMAGE = "/assets/pack-zero-franchise/pricing-image.png";

export const PricingHighlightSection = () => {
  const { trackOnlineSubscription, trackRecall } = useZeroFranchiseTracking();

  const handleSubscribe = () => {
    trackOnlineSubscription("oneprice_nomalus");
    redirectToSouscription();
  };

  const handleRecall = () => {
    trackRecall("oneprice_nomalus");
    openZendeskWidget();
  };

  return (
    <section className="px-0 md:px-10 xl:px-14">
      <div
        className={[
          "mx-auto w-full max-w-[1330px] rounded-[40px] bg-[#FFFAE0]",
          "px-4 pt-6 pb-16",
          "md:px-10 md:py-14",
          "xl:px-14 xl:py-20",
        ].join(" ")}
      >
        <div className="flex flex-col items-center gap-12 xl:flex-row xl:items-center xl:gap-[120px]">
          <div className="w-full overflow-hidden rounded-[24px] xl:w-[468px] xl:shrink-0 xl:rounded-[32px]">
            <img
              src={PRICING_IMAGE}
              alt="Famille souriante prenant un selfie dans une voiture"
              width={1404}
              height={856}
              className="block h-[209px] w-full object-cover md:h-[380px] xl:h-[423px]"
            />
          </div>

          <div className="flex w-full flex-col items-center gap-6 xl:flex-1 xl:items-start xl:gap-8">
            <h2 className="text-center text-[23px] font-bold leading-[1.2] text-[#0D0D0D] md:text-[28px] xl:text-left">
              Un seul prix, pas de malus
            </h2>

            <div className="flex w-full flex-col items-center gap-6  max-w-[380px] xl:max-w-[608px]">
              <PricingDescriptionRow
                left="Que vous ayez une vieille voiture..."
                right="qu’elle soit flambant neuve."
              />
              <img
                src="/assets/pack-zero-franchise/divider-point.svg"
                alt=""
                aria-hidden
                width={607}
                height={2}
                className="block h-[2px] w-full object-none object-center"
              />
              <PricingDescriptionRow
                left="Qu’elle dorme dans un garage verrouillé à triple tour..."
                right="dans la rue."
              />
            </div>

            <p className="text-center text-[19px] font-bold leading-[1.2] text-[#0D0D0D] xl:text-left xl:text-[23px]">
              Et on ne radie personne
            </p>

            <div className="mt-2 flex w-full max-md:max-w-[280px] flex-col items-stretch gap-3 md:mt-6 md:flex-row md:items-center md:justify-center md:gap-4 xl:justify-start">
              <Button
                variant="primary-yellow"
                className="w-full md:w-auto"
                onClick={handleSubscribe}
              >
                Souscrire en ligne
              </Button>
              <Button
                variant="outline-dark"
                className="w-full md:w-auto"
                onClick={handleRecall}
              >
                Me faire rappeler
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

interface PricingRowProps {
  left: string;
  right: string;
}

const PricingDescriptionRow = ({ left, right }: PricingRowProps) => (
  <div className="flex w-full flex-col items-center gap-3 xl:flex-row xl:items-center xl:gap-10">
    <p className="text-center text-[16px] leading-[1.6] text-[#0D0D0D] xl:flex-1 xl:text-left">
      {left}
    </p>
    <span
      aria-hidden
      className="-rotate-3 inline-flex h-[20px] items-center justify-center bg-[#FFD100] px-1.5 text-[16px] font-extrabold leading-none text-[#0D0D0D]"
    >
      ou
    </span>
    <p className="text-center text-[16px] leading-[1.6] text-[#0D0D0D] xl:flex-1 xl:text-left">
      {right}
    </p>
  </div>
);
